module.exports = __webpack_public_path__ + "img/sm.sm39b2d06.svg";